export default __webpack_public_path__ + "static/media/matchmaker-close.a33987df.svg";